import { createAction } from "@reduxjs/toolkit";

type Payload = { target: string; params?: unknown };

export const metrikaActions = {
  send: createAction<Payload>("metrika/send"),
};
